import React, { SVGProps } from 'react';

export const SubtractCircleSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M0.5 6.55859C0.5 8.01729 1.07946 9.41623 2.11091 10.4477C3.14236 11.4791 4.54131 12.0586 6 12.0586C7.45869 12.0586 8.85764 11.4791 9.88909 10.4477C10.9205 9.41623 11.5 8.01729 11.5 6.55859C11.5 5.0999 10.9205 3.70096 9.88909 2.66951C8.85764 1.63806 7.45869 1.05859 6 1.05859C4.54131 1.05859 3.14236 1.63806 2.11091 2.66951C1.07946 3.70096 0.5 5.0999 0.5 6.55859Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M9 6.55859H3' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
